import {Gender} from "../../enums/gender.enum";
import {IsBeforeDate} from "../../validators/isBeforeDate.validator";
import moment from "moment/moment";
import {IsNotEmpty} from "class-validator";

class AccountSettingsForm {

    allowMarketing: boolean;
    
    gender: Gender;

    @IsBeforeDate(moment().subtract(13, 'years').toDate(), {message: "You must be over 13 years old"})
    @IsNotEmpty({message: "Please enter your date of birth"})
    dateOfBirth: Date;
}

export { AccountSettingsForm }